import { Service } from '../service.js';
import { env } from '../env.js';

class CepService extends Service {
    constructor() {
        super();
        this.url = env.url + "cep";
    }

    async getCepInformations(cep) {
        const cepWithoutHyphen = cep.replace('-', '');
        const url = `${this.url}/${cepWithoutHyphen}`;
        return super.get(url);
    }
}

export const cepService = new CepService()